import React from "react";
import { Globe, Smartphone, Download, ExternalLink, ArrowRight } from "lucide-react";

export const ChatSupport = () => {
  return (
    <div className="bg-gradient-to-br from-slate-50 to-slate-100 py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">

        {/* Platform Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Web Application Card */}
          <div className="group hidden bg-white border border-slate-200 rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:border-blue-300 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            
            <div className="relative z-10">
              <div className="flex items-center justify-between mb-6">
                <div className="p-3 bg-blue-100 rounded-xl group-hover:bg-blue-200 transition-colors duration-300">
                  <Globe className="text-blue-600 h-8 w-8" />
                </div>
                <div className="px-3 py-1 bg-slate-100 text-slate-600 text-sm font-medium rounded-full">
                  web
                </div>
              </div>
              
              <h2 className="text-2xl font-bold text-slate-900 mb-3">Web Application</h2>
              <p className="text-slate-600 mb-8 leading-relaxed">
                Access the complete suite of features with our full-featured web platform. 
                Perfect for detailed study sessions and comprehensive guidance.
              </p>
              
              <div className="space-y-3 mb-8">
                <div className="flex items-center text-sm text-slate-600">
                  <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-3"></div>
                  Full feature access
                </div>
                <div className="flex items-center text-sm text-slate-600">
                  <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-3"></div>
                  Optimized for desktop
                </div>
                <div className="flex items-center text-sm text-slate-600">
                  <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-3"></div>
                  No installation required
                </div>
              </div>
              
              <a
                href="https://chat.alguidance.lk"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-full px-6 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-all duration-200 group/btn"
              >
                <ExternalLink className="mr-2 h-5 w-5" />
                Launch Web App
                <ArrowRight className="ml-2 h-4 w-4 group-hover/btn:translate-x-1 transition-transform duration-200" />
              </a>
            </div>
          </div>

          {/* Android Application Card */}
          <div className="group bg-white border border-slate-200 rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:border-[#01b26e] relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-[#01b26e]50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            
            <div className="relative z-10">
              <div className="flex items-center justify-between mb-6">
                <div className="p-3 bg-green-100 rounded-xl group-hover:bg-green-200 transition-colors duration-300">
                  <Smartphone className="text-[#01b26e] h-8 w-8" />
                </div>
                <div className="px-3 py-1 bg-slate-100 text-slate-600 text-sm font-medium rounded-full">
                    Recommended
                </div>
              </div>
              
              <h2 className="text-2xl font-bold text-slate-900 mb-3">Android Application</h2>
              <p className="text-slate-600 mb-8 leading-relaxed">
                Take your learning on the go with our native Android app. 
                Optimized for mobile learning with offline capabilities.
              </p>
              
              <div className="space-y-3 mb-8">
                <div className="flex items-center text-sm text-slate-600">
                  <div className="w-1.5 h-1.5 bg-[#01b26e] rounded-full mr-3"></div>
                  Native mobile experience
                </div>
                <div className="flex items-center text-sm text-slate-600">
                  <div className="w-1.5 h-1.5 bg-[#01b26e] rounded-full mr-3"></div>
                  Offline content access
                </div>
                <div className="flex items-center text-sm text-slate-600">
                  <div className="w-1.5 h-1.5 bg-[#01b26e] rounded-full mr-3"></div>
                  Push notifications
                </div>
              </div>
              
              <a
                href="https://api-alguidance.b-cdn.net/application-765c7d60-f005-4541-a328-ad05fd6ef60b.apk"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-full px-6 py-4 bg-[#01b26e] hover:bg-[#01b26e] text-white font-semibold rounded-xl transition-all duration-200 group/btn"
              >
                <Download className="mr-2 h-5 w-5" />
                Download App
                <ArrowRight className="ml-2 h-4 w-4 group-hover/btn:translate-x-1 transition-transform duration-200" />
              </a>
            </div>
          </div>
        </div>

        {/* Additional Info Section */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center px-6 py-3 bg-white border border-slate-200 rounded-xl shadow-sm">
            <div className="flex items-center space-x-2 text-sm text-slate-600">
              <div className="w-2 h-2 bg-[#01b26e] rounded-full animate-pulse"></div>
              <span>Both platforms are regularly updated with new features</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};